/**
 * @module src/utils/core-methods
 * @author lwc
 * @description 公共方法分装.
 * @date 2020年12月1日
 * */

import Vue from 'vue'
import i18n from '@/lang'

const coreMethods = {}
const _this = new Vue()

/**
 * 通知弹框公共方法
 * @desc 用于做提示操作的
 * @author lwc
 * @date 2020年12月1日
 * @type {String} - 参数说明: 弹框类型，有四个值：success,warning,info,error
 * @content {String} - 参数说明: 提示内容
 * @isHtml {Boolean} - 参数说明: true/false,默认值为false;是否使用HTML片段
 * @example 调用示例
 */
coreMethods.message = function(type, content, isHtml = false) {
  if (type === 'success') {
    _this.$message({
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'success',
      duration: 2500,
    })
  } else if (type === 'warning') {
    _this.$message({
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'warning',
      duration: 2500,
    })
  } else if (type === 'info') {
    _this.$message.info({
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'info',
      duration: 2500,
    })
  } else {
    _this.$message.error({
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'error',
      duration: 2500,
    })
  }
}

/**
 * 通知弹框公共方法
 * @desc 用于做提示操作的
 * @author lwc
 * @date 2020年12月1日
 * @type {String} - 参数说明: 弹框类型，有四个值：success,warning,info,error
 * @content {String} - 参数说明: 提示内容
 * @title {String}  - 参数说明: 提示弹框标题，有默认值
 * @isHtml {Boolean} - 参数说明: true/false,默认值为false;是否使用HTML片段
 * @example 调用示例
 */
coreMethods.notification = function(type, content, title, isHtml = false) {
  if (type === 'success') {
    _this.$notify({
      title: title || i18n.t('message.success'),
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'success',
      duration: 2500,
      offset: 50
    })
  } else if (type === 'warning') {
    _this.$notify({
      title: title || i18n.t('message.warning'),
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'warning',
      duration: 2500,
      offset: 50
    })
  } else if (type === 'info') {
    _this.$notify.info({
      title: title || i18n.t('message.info'),
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'info',
      duration: 2500,
      offset: 50
    })
  } else {
    _this.$notify.error({
      title: title || i18n.t('message.error'),
      dangerouslyUseHTMLString: isHtml,
      message: content,
      type: 'error',
      duration: 30000,
      offset: 50
    })
  }
}

/**
 * 弹框公共方法
 * @desc 用于阻断程序运行的
 * @author lwc
 * @date 2020年12月1日
 * @rightCallBack {String} - 参数说明: 确认之后的回调函数
 * @closeCallBack {String} - 参数说明: 关闭的回调函数
 * @flag {Boolean}  - 参数说明: 弹框类型是否为双按钮，默认值为false
 * @content {String} - 参数说明: 提示内容
 * @title {String}  - 参数说明: 提示弹框标题，有默认值
 * @type {Boolean} - 参数说明: 弹框类型，有四个值：success,warning,info,error
 * @isHtml {String}  - 参数说明: true/false,默认值为false;是否使用HTML片段
 * @isShowClose {Boolean} - 参数说明: true/false,默认值为true;是否显示右上角关闭按钮
 * @example 调用示例
 */
coreMethods.confirm = function(rightCallBack, closeCallBack, flag = false, content = '当前页面有修改，请先保存', title = '提示', type = 'warning', isHtml = false, isShowClose = true) {
  if (flag) {
    _this.$alert(content, title, {
      dangerouslyUseHTMLString: isHtml,
      confirmButtonText: i18n.t('message.confirm'),
      type: type,
      center: true,
      showClose: isShowClose,
      callback: action => {
        if (action === 'confirm') {
          if (typeof rightCallBack === 'function') {
            rightCallBack()
          }
        }
      }
    })
  } else {
    _this.$confirm(content, title, {
      dangerouslyUseHTMLString: isHtml,
      confirmButtonText: i18n.t('message.yes'),
      cancelButtonText: i18n.t('message.no'),
      confirmButtonClass: 'certainBtnClass',
      type: type,
      center: true,
      showClose: isShowClose
    }).then(() => {
      rightCallBack()
    }).catch(() => {
      if (typeof closeCallBack === 'function') {
        closeCallBack()
      }
    })
  }
}

export default coreMethods
